import MovieInfo from './MovieInfo';

export default MovieInfo;
